import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { ReactiveFormsModule } from "@angular/forms";
import { CalendarModule } from "ion2-calendar";
import { ScrollingModule } from "@angular/cdk/scrolling";

import { IonicModule } from "@ionic/angular";

import { PeopleModalPage } from "./people-modal.page";

const routes: Routes = [
  {
    path: "",
    component: PeopleModalPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    ScrollingModule,
    RouterModule.forChild(routes),
    //CalendarModule
  ],
  declarations: [PeopleModalPage],
})
export class PeopleModalPageModule {}
